module.exports = __webpack_public_path__ + "static/img/user.044db27a.svg";